const es = {
  "nav.chefs": "Nuestros Chefs",
  "nav.experiences": "Experiencias",
  "nav.privateDining": "Cena Privada",
  "nav.journal": "Journal",
  "nav.howItWorks": "Cómo Funciona",
  "nav.events": "Eventos",
  "nav.corporate": "Empresas",
  "nav.bespoke": "A Medida",
  "nav.giftCards": "Tarjetas Regalo",
  "nav.becomeChef": "Hazte Chef",
  "nav.about": "Nosotros",
  "nav.contact": "Contacto",
  "nav.faq": "FAQ",
  "nav.login": "Iniciar Sesión",
  "nav.logout": "Cerrar Sesión",
  "nav.account": "Mi Cuenta",
  "nav.findChef": "Encontrar Mi Chef",
  "nav.more": "Más",
  "hero.line1": "Cocina Excepcional.",
  "hero.line2": "En Tu Casa.",
  "hero.sub": "Chefs privados verificados crean experiencias gastronómicas de cinco estrellas en la intimidad de tu comedor. En París y más allá.",
  "hero.badge": "Conserjería de Chefs Privados",
  "search.location": "Ciudad",
  "search.date": "Fecha",
  "search.guests": "Comensales",
  "search.cuisine": "Cocina",
  "search.experience": "Experiencia",
  "search.any": "Todas",
  "search.cta": "Encontrar Mi Chef",
  "home.featuredEyebrow": "La Selección de la Maison",
  "home.featuredTitle": "Chefs de Distinción",
  "home.viewAll": "Ver todos los chefs",
  "home.expEyebrow": "Experiencias Signature",
  "home.expTitle": "Seis Maneras de Cenar de Forma Extraordinaria",
  "home.trustEyebrow": "Nuestra Promesa",
  "home.trustTitle": "Cada Chef, Cuidadosamente Seleccionado",
  "home.trustIntro": "Detrás de cada insignia «Chef Verificado» hay una rigurosa verificación profesional. Solo admitimos chefs que completan nuestra revisión — tu mesa siempre está en manos expertas.",
  "trust.i1": "Verificación de identidad (KYC)",
  "trust.i2": "Revisión de la experiencia profesional",
  "trust.i3": "Revisión de perfil y portafolio",
  "trust.i4": "Revisión de prácticas de cocina",
  "trust.i5": "Estándares del portafolio de platos",
  "trust.i6": "Documentación de higiene aplicable",
  "trust.i7": "Cumplimiento bancario",
  "home.manifestoEyebrow": "El Manifiesto",
  "man.c1t": "La Mesa Es Sagrada",
  "man.c1b": "Una cena en casa no es un reparto. Es teatro, hospitalidad y oficio — compuesta para quienes amas, en el lugar que más amas.",
  "man.c2t": "Oficio Antes Que Comodidad",
  "man.c2b": "Nuestros chefs compran en los mercados matinales, cocinan en tu cocina y sirven plato a plato. Nada recalentado, nada ordinario.",
  "man.c3t": "Confianza Verificada",
  "man.c3b": "Cada chef de Chef à Domicile pasa una verificación profesional antes de servir un solo plato. La excelencia es el requisito de entrada.",
  "home.marquee": "Chef Privado París — Chef à Domicile — Cena Privada de Lujo — Menús a Medida — Hospitalidad Cinco Estrellas —",
  "home.ctaTitle": "Tu mesa merece un chef.",
  "home.ctaBtn": "Reservar una Experiencia",
  "home.journalEyebrow": "El Journal",
  "home.journalTitle": "Historias de la Mesa",
  "common.verified": "Chef Verificado",
  "common.perGuest": "por comensal",
  "common.from": "Desde",
  "common.viewProfile": "Ver Perfil",
  "common.book": "Reservar",
  "common.loading": "Cargando…",
  "common.error": "Algo salió mal.",
  "common.retry": "Reintentar",
  "common.empty": "Nada aquí todavía.",
  "common.readMore": "Leer más",
  "common.back": "Volver",
  "common.send": "Enviar",
  "common.sending": "Enviando…",
  "common.yearsExp": "{n} años de experiencia",
  "common.reviews": "reseñas",
  "common.languages": "Idiomas",
  "common.all": "Todas",
  "common.cancel": "Cancelar",
  "common.save": "Guardar",
  "common.delete": "Eliminar",
  "common.add": "Añadir",
  "common.optional": "opcional",
  "common.next": "Continuar",
  "common.confirm": "Confirmar",
  "common.total": "Total",
  "common.guests": "comensales",
  "chefs.title": "El Marketplace de Chefs Verificados",
  "chefs.sub": "Chefs privados de excepción, verificados por nuestro equipo, listos para cocinar en tu casa.",
  "chefs.filters": "Filtros",
  "chefs.clear": "Borrar filtros",
  "chefs.cuisine": "Cocina",
  "chefs.city": "Ciudad",
  "chefs.minRating": "Valoración mínima",
  "chefs.maxPrice": "Precio máx / comensal",
  "chefs.language": "Idioma del chef",
  "chefs.noResults": "Ningún chef coincide con estos criterios. Amplía tu búsqueda.",
  "chefs.count": "{n} chef(s) verificado(s)",
  "chef.about": "Sobre el Chef",
  "chef.signature": "Platos Signature",
  "chef.reviews": "Reseñas de Comensales",
  "chef.bookThis": "Reservar este Chef",
  "chef.qualification": "Cualificación",
  "chef.allergens": "Alérgenos",
  "chef.dietary": "Dietas",
  "chef.prep": "{n} min de preparación",
  "exp.title": "Experiencias Signature",
  "exp.sub": "Seis formas seleccionadas de llevar la alta cocina a casa — de una cena íntima a la carta a un evento gastronómico totalmente a medida.",
  "booking.title": "Reserva Tu Experiencia",
  "booking.step1": "Menú",
  "booking.step2": "Detalles",
  "booking.step3": "Confirmar y Pagar",
  "booking.selectDish": "Elige un plato signature",
  "booking.date": "Fecha",
  "booking.time": "Hora",
  "booking.address": "Dirección",
  "booking.city": "Ciudad",
  "booking.occasion": "Ocasión",
  "booking.requests": "Peticiones especiales",
  "booking.create": "Revisar mi reserva",
  "booking.promo": "Código promo o tarjeta regalo",
  "booking.promoApply": "Aplicar",
  "booking.promoApplied": "Código aplicado",
  "booking.chef": "Tu Chef",
  "booking.pricePerGuest": "Precio por comensal",
  "booking.pay": "Ir al Pago Seguro",
  "booking.payNote": "Serás redirigido a un pago seguro de Stripe. El importe final lo calcula nuestro servicio.",
  "booking.loginFirst": "Inicia sesión para completar tu reserva.",
  "booking.stripeOff": "El pago online no está disponible temporalmente. Tu reserva está guardada — nuestra conserjería te contactará para finalizar el pago.",
  "booking.discount": "Descuento",
  "pay.checking": "Confirmando tu pago…",
  "pay.success": "Pago confirmado. Tu chef ha sido avisado — nos vemos en la mesa.",
  "pay.failed": "El pago no se completó.",
  "pay.pending": "El pago sigue procesándose. Esta página se actualizará automáticamente.",
  "pay.backAccount": "Ir a mis reservas",
  "auth.loginTitle": "Bienvenido de Nuevo",
  "auth.registerTitle": "Crea Tu Cuenta",
  "auth.email": "Email",
  "auth.password": "Contraseña",
  "auth.name": "Nombre completo",
  "auth.loginBtn": "Iniciar Sesión",
  "auth.registerBtn": "Crear Cuenta",
  "auth.toRegister": "¿Nuevo en Chef à Domicile? Crea una cuenta",
  "auth.toLogin": "¿Ya eres miembro? Inicia sesión",
  "account.title": "Mi Cuenta",
  "account.bookings": "Reservas",
  "account.favorites": "Favoritos",
  "account.giftcards": "Tarjetas Regalo",
  "account.dietary": "Perfil Alimentario",
  "account.addresses": "Direcciones",
  "account.noBookings": "Sin reservas todavía. Tu próxima cena excepcional te espera.",
  "account.noFavorites": "Sin chefs favoritos todavía.",
  "account.status": "Estado",
  "account.cancelBooking": "Cancelar reserva",
  "account.review": "Dejar una reseña",
  "account.reviewComment": "Tu comentario",
  "account.messages": "Mensajes",
  "account.writeMsg": "Escribe un mensaje a tu chef…",
  "account.allergies": "Alergias",
  "account.diets": "Dietas y preferencias",
  "account.saveProfile": "Guardar perfil",
  "account.addAddress": "Añadir dirección",
  "account.label": "Etiqueta (Casa, Oficina…)",
  "account.noGiftcards": "Sin pedidos de tarjetas regalo.",
  "account.commaHint": "Separa con comas",
  "gift.title": "El Regalo de una Mesa Inolvidable",
  "gift.sub": "Regala una experiencia de chef privado. El destinatario recibe una elegante tarjeta regalo, canjeable en cualquier reserva.",
  "gift.amount": "Importe (25 € – 1000 €)",
  "gift.recipientName": "Nombre del destinatario",
  "gift.recipientEmail": "Email del destinatario",
  "gift.message": "Mensaje personal",
  "gift.buy": "Comprar Tarjeta Regalo",
  "gift.note": "El código se genera y envía por email solo tras confirmarse el pago.",
  "becomeChef.title": "Cocina para las Mesas Más Bellas",
  "becomeChef.sub": "Únete a Chef à Domicile como chef privado. Tus menús, tus precios, tu agenda — nosotros te traemos clientes exigentes.",
  "becomeChef.cta": "Postular como Chef",
  "becomeChef.bio": "Tu historia y trayectoria culinaria",
  "becomeChef.years": "Años de experiencia",
  "becomeChef.qualification": "Cualificación / formación",
  "becomeChef.city": "Ciudad",
  "becomeChef.cuisines": "Tus cocinas",
  "becomeChef.success": "Candidatura recibida. Tu perfil entra en nuestro proceso de verificación profesional — nuestro equipo te contactará.",
  "becomeChef.s1t": "Postula",
  "becomeChef.s1b": "Cuéntanos tu experiencia, formación y cocina signature.",
  "becomeChef.s2t": "Verifícate",
  "becomeChef.s2b": "Identidad, experiencia, prácticas de cocina y portafolio se revisan profesionalmente.",
  "becomeChef.s3t": "Cocina y Gana",
  "becomeChef.s3b": "Recibe reservas de clientes refinados y cobra con seguridad.",
  "inquiry.contactTitle": "Contactar con la Maison",
  "inquiry.contactSub": "Una pregunta, un proyecto, una petición especial — nuestra conserjería responde en 24 horas.",
  "inquiry.corporateTitle": "Experiencias para Empresas",
  "inquiry.corporateSub": "Cenas ejecutivas, atención a clientes, celebraciones de equipo — cocina a la altura de tu empresa.",
  "inquiry.corporateCta": "Solicitar una Experiencia Corporativa",
  "inquiry.eventsTitle": "Eventos de Cualquier Escala",
  "inquiry.eventsSub": "Cumpleaños, bodas, recepciones — una producción culinaria completa, del menú al servicio.",
  "inquiry.eventsCta": "Planear Mi Evento",
  "inquiry.bespokeTitle": "Menús Totalmente a Medida",
  "inquiry.bespokeSub": "Un menú único, diseñado con tu chef en torno a tu historia, tus productos, tu ocasión.",
  "inquiry.bespokeCta": "Iniciar un Proyecto a Medida",
  "inquiry.eventType": "Tipo de evento",
  "inquiry.budget": "Presupuesto",
  "inquiry.location": "Lugar",
  "inquiry.company": "Empresa",
  "inquiry.phone": "Teléfono",
  "inquiry.date": "Fecha deseada",
  "inquiry.guests": "Comensales",
  "inquiry.message": "Tu mensaje",
  "inquiry.success": "Gracias. Nuestro equipo de conserjería te contactará muy pronto.",
  "how.title": "Cómo Funciona",
  "how.sub": "Del primer clic al último plato — sin esfuerzo, en cuatro movimientos.",
  "how.s1t": "01 — Compón",
  "how.s1b": "Elige ciudad, fecha, comensales y cocina. Explora chefs verificados y sus platos signature.",
  "how.s2t": "02 — Reserva",
  "how.s2b": "Reserva en minutos. El precio se calcula con transparencia por comensal — sin costes ocultos.",
  "how.s3t": "03 — Recibe a Tu Chef",
  "how.s3b": "Tu chef llega con producto fresco, cocina en tu cocina y sirve plato a plato.",
  "how.s4t": "04 — Simplemente Disfruta",
  "how.s4b": "Tu chef deja la cocina impecable. Tú te quedas con los recuerdos — y los cumplidos.",
  "about.title": "La Maison",
  "about.p1": "Chef à Domicile nació de una convicción simple: el restaurante más memorable del mundo es tu propia casa. Conectamos anfitriones exigentes con chefs privados verificados que transforman un comedor en una mesa de cinco estrellas.",
  "about.p2": "Desde París hacia el mundo, nuestro marketplace de nivel conserjería selecciona chefs de 28 cocinas del mundo — cada uno verificado profesionalmente en identidad, experiencia, prácticas de cocina y portafolio.",
  "about.p3": "No somos reparto de comida. Somos hospitalidad — el arte de la mesa, llevado a casa.",
  "privateDining.title": "La Cena Privada, Perfeccionada",
  "privateDining.sub": "Cenas íntimas de 2 a 20 comensales, orquestadas por un chef privado verificado.",
  "privateDining.p1": "Una velada con Chef à Domicile empieza mucho antes del primer plato. Tu chef diseña el menú contigo, selecciona el mejor producto de la mañana y llega listo para transformar tu cocina en el pase de un gran restaurante.",
  "privateDining.p2": "Los platos se suceden en tu mesa — mientras tú te quedas con tus invitados. Al final de la noche, la cocina queda impecable.",
  "privateDining.cta": "Encontrar un Chef para Mi Cena",
  "faq.title": "Preguntas Frecuentes",
  "faq.q1": "¿Cómo se verifican los chefs?",
  "faq.a1": "Cada chef pasa una verificación profesional: identidad (KYC), experiencia profesional, revisión de perfil, prácticas de cocina, portafolio de platos, documentación de higiene aplicable y cumplimiento bancario. Solo los chefs verificados aparecen en el marketplace.",
  "faq.q2": "¿Qué incluye el precio por comensal?",
  "faq.a2": "La compra del chef, la preparación, la cocina, el servicio de mesa del menú y la limpieza de la cocina. El total lo calcula con transparencia nuestro servicio al reservar.",
  "faq.q3": "¿Se adaptan los menús a alergias o dietas?",
  "faq.a3": "Sí. Guarda alergias y preferencias en tu perfil alimentario y añade peticiones especiales a cualquier reserva — tu chef adapta el menú.",
  "faq.q4": "¿Cómo funciona el pago?",
  "faq.a4": "Los pagos se procesan de forma segura con Stripe. Solo se te cobra al confirmar la reserva; tarjetas regalo y códigos promo se aplican antes del pago.",
  "faq.q5": "¿Puedo cancelar una reserva?",
  "faq.a5": "Sí, desde tu cuenta. Consulta nuestra política de cancelación según el plazo de aviso.",
  "journal.title": "El Journal",
  "journal.sub": "Gastronomía, hospitalidad y el arte de la mesa — por Chef à Domicile.",
  "journal.empty": "Se están escribiendo nuevas historias. Vuelve pronto.",
  "journal.related": "Historias Relacionadas",
  "legal.termsTitle": "Condiciones del Servicio",
  "legal.privacyTitle": "Política de Privacidad",
  "legal.cancelTitle": "Política de Cancelación",
  "legal.terms1": "Chef à Domicile opera un marketplace que conecta clientes con chefs privados independientes y verificados. Al usar chef-adomicile.com aceptas estas condiciones. La reserva forma un contrato entre cliente y chef, facilitado por Chef à Domicile.",
  "legal.terms2": "Los precios se muestran por comensal; el total final lo calcula nuestro servicio al reservar. El pago lo procesa nuestro socio seguro. Los chefs son profesionales independientes responsables del servicio culinario.",
  "legal.terms3": "Todo el contenido, marca e imágenes de este sitio pertenecen a Chef à Domicile. El mal uso de la plataforma puede conllevar la suspensión de la cuenta.",
  "legal.privacy1": "Recogemos solo los datos necesarios para tu cuenta y reservas: identidad, contacto, direcciones, preferencias alimentarias e historial. Nunca vendemos tus datos.",
  "legal.privacy2": "Los datos de pago los gestiona exclusivamente nuestro socio de pago; Chef à Domicile nunca almacena números de tarjeta.",
  "legal.privacy3": "Puedes solicitar acceso, corrección o eliminación de tus datos personales en cualquier momento a través de la página de contacto.",
  "legal.cancel1": "Puedes cancelar una reserva desde tu cuenta. Las cancelaciones con suficiente antelación se reembolsan según las condiciones comunicadas al reservar.",
  "legal.cancel2": "Las cancelaciones tardías pueden conllevar gastos, ya que el chef habrá comprado producto y reservado la fecha. Los pagos con tarjeta regalo se reabonan a la tarjeta.",
  "legal.cancel3": "Si un chef debe cancelar, nuestra conserjería propone un chef verificado equivalente o el reembolso íntegro, a tu elección.",
  "footer.tag": "Cocina Excepcional. En Tu Casa.",
  "footer.explore": "Explorar",
  "footer.company": "La Maison",
  "footer.legal": "Legal",
  "footer.rights": "© 2026 Chef à Domicile — Tous droits réservés / All rights reserved",
  "seo.homeTitle": "Chef à Domicile — Chef Privado a Domicilio | Cena Privada de Lujo",
  "seo.homeDesc": "Reserva un chef privado verificado para una cena excepcional en casa. Cena privada de lujo en París y más allá — menús a medida, eventos, experiencias corporativas.",
};
export default es;
